import { render, staticRenderFns } from "./devoluciones.vue?vue&type=template&id=7b2440ec&lang=html"
import script from "./devoluciones.vue?vue&type=script&lang=js"
export * from "./devoluciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports